export default function () {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="19" viewBox="0 0 22 19" fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20.1898 7.84277V7.83043C20.1881 7.08436 20.5517 6.38435 21.2122 6.0109L21.5 5.84885L20.0165 3.3367L19.7228 3.50368C19.0858 3.86233 18.2982 3.86726 17.6687 3.49546C17.6149 3.46338 17.5602 3.43294 17.5047 3.40251C16.866 3.05702 16.4831 2.38745 16.4831 1.67427V1.34277H13.5169V1.67427C13.5169 2.38745 13.134 3.05702 12.4953 3.40251C12.4406 3.43294 12.3851 3.46338 12.3313 3.49546C11.7018 3.86726 10.9142 3.86233 10.2772 3.50368L9.98353 3.3367L8.5 5.84885L8.78779 6.0109C9.44835 6.38435 9.81187 7.08436 9.81018 7.83043V7.84277V7.85511C9.81187 8.60119 9.44835 9.3012 8.78779 9.67465L8.5 9.8367L9.98353 12.348L10.2772 12.1819C10.9142 11.8232 11.7018 11.8183 12.3313 12.1901C12.3851 12.2222 12.4406 12.2526 12.4953 12.283C13.134 12.6285 13.5169 13.2981 13.5169 14.0113V14.3428H16.4831V14.0113C16.4831 13.2981 16.866 12.6285 17.5047 12.283C17.5602 12.2526 17.6149 12.2222 17.6687 12.1901C18.2982 11.8183 19.0858 11.8232 19.7228 12.1819L20.0165 12.348L21.5 9.8367L21.2122 9.67465C20.5517 9.3012 20.1881 8.60119 20.1898 7.85511V7.84277Z"
                stroke="url(#paint0_linear_1135_1008)"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <rect x="1" y="5.34277" width="17" height="12.2" rx="0.5" fill="#FDF6E8" stroke="url(#paint1_linear_1135_1008)" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.4999 7.54297V9.54297L1.5 9.54297V7.54297L17.4999 7.54297Z"
                fill="url(#paint2_linear_1135_1008)"
            />
            <path fillRule="evenodd" clipRule="evenodd" d="M5.05956 14.4424V15.3592H3.29957V14.4424H5.05956Z" fill="#D09D5C" />
            <path fillRule="evenodd" clipRule="evenodd" d="M8.66015 14.4424V15.3592H6.90016V14.4424H8.66015Z" fill="#D09D5C" />
            <defs>
                <linearGradient id="paint0_linear_1135_1008" x1="18" y1="3.34277" x2="15" y2="14.3428" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#E9BF7E" />
                    <stop offset="1" stopColor="#D6A665" />
                </linearGradient>
                <linearGradient id="paint1_linear_1135_1008" x1="17" y1="5.04272" x2="1.5" y2="18.0427" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FBD896" />
                    <stop offset="1" stopColor="#CD9958" />
                </linearGradient>
                <linearGradient id="paint2_linear_1135_1008" x1="17.5" y1="9.54297" x2="0.999999" y2="9.54297" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F3CD8B" />
                    <stop offset="1" stopColor="#DCAD6C" />
                </linearGradient>
            </defs>
        </svg>
    );
}
